import {Component} from "@angular/core";
import {StoreConfigService} from "../storeconfig.service";
import {StoreConfig} from "../storeconfig.model";
import {RerunMergingDialogComponent} from "../rerun-merging-dialog/rerun-merging-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
  selector: "app-store-config-list",
  templateUrl: "./store-config-list.component.html",
  styleUrls: ["./store-config-list.component.css"],
})
export class StoreConfigListComponent {
  displayedColumns: string[] = ["storeName", "configName", "createTime"];
  storeConfigs: StoreConfig[] = [];
  storeConfigListTotalElements: number = 0;
  storeConfigListPageIndex: number = 0;
  storeConfigListPageSize: number = 500;
  storeSearchFormGroup: FormGroup;

  dataSource;

  constructor(
    private dialog: MatDialog,
    private storeConfigService: StoreConfigService,
    private fb: FormBuilder,
  ) {
    this.storeSearchFormGroup = this.fb.group({
      storeNameSearchValue: ['']
    });
    this.fetchStoreConfigs();
  }

  updateStoreConfigs(response) {
    this.storeConfigs = response.storeConfigs;
    this.dataSource = new MatTableDataSource(this.storeConfigs);
    this.storeConfigListTotalElements = response.totalElements;
  }

  fetchStoreConfigs() {
    this.storeConfigService.fetchStoreConfigs(
      this.storeSearchFormGroup.get("storeNameSearchValue").value,
      this.storeConfigListPageIndex,
      this.storeConfigListPageSize)
      .subscribe((response) => {
        this.updateStoreConfigs(response);
      });
  }

  onChangePage(event) {
    this.storeConfigListPageIndex = event.pageIndex;
    this.storeConfigListPageSize = event.pageSize;
    this.fetchStoreConfigs();
  }

  onSubmitSearch() {
    this.storeConfigListPageIndex = 0
    this.fetchStoreConfigs();
  }

  showRerunMergingView() {
    this.dialog.open(RerunMergingDialogComponent, {
      width: "600px",
      disableClose: true,
      data: {
        store: null,
      },
    });
  }
}
